import { render, staticRenderFns } from "./UpdateDelivery.vue?vue&type=template&id=425025d2&scoped=true"
import script from "./UpdateDelivery.vue?vue&type=script&lang=js"
export * from "./UpdateDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425025d2",
  null
  
)

export default component.exports